package de.katoonerie.content

import androidx.compose.runtime.Composable
import de.katoonerie.components.Container
import de.katoonerie.components.Gradient
import de.katoonerie.components.Prose
import de.katoonerie.contentful.Homepage
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img

@Composable
fun Homepage.Home() {
    Banner()
    Gradient {
        Container {
            NavigationBars()
            Introduction()
        }
    }
}

@Composable
fun Homepage.Banner() {
    Img(src = bannerUrl.toString(), attrs = {
        classes("mb-8", "h-48", "w-full", "object-cover", "lg:h-56", "xl:h-64", "2xl:h-72")
    })
}

@Composable
fun Homepage.NavigationBars() {
    Div(attrs = { classes("flex", "flex-wrap", "flex-row", "justify-center") }) {
        Div(attrs = { classes("w-24", "h-1") })
        Div(attrs = { classes("py-4", "mx-2", "sm:mx-12") }) {
            navigationBars.forEach { navigationBar ->
                navigationBar.NavigationBar(preview)
            }
        }
        Div(attrs = { classes("flex", "flex-col", "place-content-center") }) {
            actionsBar.NavigationBar(
                preview,
                tileIconAttrs = { classes("w-24", "h-32", "px-2") },
                tileImageAttrs = { classes("pt-4", "max-h-[120px]", "mx-auto") }
            )
        }
    }
}

@Composable
fun Homepage.Introduction() {
    Prose(attrs = { classes("mx-auto", "prose-lg", "p-4") }) {
        introduction.document.Content(
            mediaAttrs = {
                classes("p-4", "flex", "justify-center", "md:mx-8", "lg:mx-12")
            }
        )
    }
}
